import { render, staticRenderFns } from "./WelcomeRecentInvoices.vue?vue&type=template&id=64f564c6&scoped=true&lang=pug&"
import script from "./WelcomeRecentInvoices.vue?vue&type=script&lang=js&"
export * from "./WelcomeRecentInvoices.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeRecentInvoices.vue?vue&type=style&index=0&id=64f564c6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f564c6",
  null
  
)

export default component.exports